import Component from "./PaymentOption";

export default Component;
